"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var widget_error_html_1 = __importDefault(require("./widget-error.html"));
require("./widget-error.less");
(function (module) {
    'use strict';
    module.directive('prWidgetError', [
        function () {
            return {
                templateUrl: widget_error_html_1.default
            };
        }
    ]);
}(angular.module('qualtrics.pr')));
